//import _ from "lodash";
//
//const Str = {
//  strtolower: (str: string) => {
//    return _.toLower(str);
//  },
//  strtoupper: (str: string) => {
//    return _.toUpper(str);
//  },
//  ucfirst: (str: string) => {
//    return _.upperFirst(str);
//  },
//  ucwords: (str: string) => {
//    return _.startCase(str);
//  },
//  lcfirst: (str: string) => {
//    return _.lowerFirst(str);
//  },
//};
const Str = {
  //use js function
  strtolower: (str: string) => {
    return str.toLowerCase();
  },
  strtoupper: (str: string) => {
    return str.toUpperCase();
  },
  ucfirst: (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },
  ucwords: (str: string) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  },
  lcfirst: (str: string) => {
    return str.charAt(0).toLowerCase() + str.slice(1);
  },
};
export default Str;
